const contactsTitles = [...document.querySelectorAll('.j-contacts-title')];
const activeClass = 'is-active';

contactsTitles.forEach((item) => {
    item.addEventListener('click', () => {
        item.classList.toggle(activeClass);
        item.nextElementSibling.classList.toggle(activeClass);
    });
});
